import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksCalendarButton.module.scss';

interface Props extends React.ComponentProps<'button'> {
  className?: string;
  disabled?: boolean;
  customType: string;
  onClick?: () => void;
}

const BooksCalendarButton = ({
  className,
  intl,
  customType,
  disabled,
  onClick,
  ...attr
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksCalendarButton, className, {
    [css.isNext]: customType === 'next',
    [css.isPrev]: customType === 'prev',
    [css.isToday]: customType === 'today',
  });

  return (
    <button {...attr} className={classes} disabled={disabled} onClick={onClick}>
      {customType === 'today' &&
        intl.formatMessage({ id: 'books.calendar.today' })}
    </button>
  );
};

export default injectIntl(BooksCalendarButton);
